import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const LandingDashboardCard = ({ children, title, to, id = '' }) => (
  <Box boxShadow={25} sx={{ borderRadius: '16px', overflow: 'hidden', backgroundColor: '#fff' }} data-introid={id}>
    <Box pt={1} px={2} display="flex" justifyContent="space-between">
      <Typography variant="subtitle2">{title}</Typography>
      <Box component={Link} to={to} sx={{ color: 'primary.main' }}>
        See more
      </Box>
    </Box>
    {children}
  </Box>
);

export default LandingDashboardCard;
